/**
 * 🛠️ Utilitaire de gestion des erreurs pour les listings
 * Simple et efficace - Pas de sur-ingénierie
 */

/**
 * Mapping des erreurs backend vers les clés i18n
 * Ajouter de nouvelles entrées au fur et à mesure
 */
const ERROR_MAP = {
  // Codes HTTP standards
  400: 'listing.errors.badRequest',
  401: 'listing.errors.unauthorized',
  403: 'listing.errors.forbidden',
  404: 'listing.errors.notFound',
  409: 'listing.errors.conflict',
  500: 'listing.errors.serverError',
  
  // Codes d'erreur réseau
  'ERR_NETWORK': 'errors.network',
  'ERR_SSL_PROTOCOL_ERROR': 'errors.sslProtocol',
  'ECONNABORTED': 'errors.timeout',
  
  // Codes d'erreur spécifiques backend (errorKey)
  'TITLE_REQUIRED': 'listing.errors.titleRequired',
  'CATEGORY_REQUIRED': 'listing.errors.categoryRequired',
  'INVALID_COORDINATES': 'listing.errors.coordinatesInvalid',
  'DUPLICATE_PERIOD': 'listing.errors.duplicatePeriod',
  'PERIOD_OVERLAP': 'listing.errors.duplicatePeriod'
};

/**
 * Extrait un message d'erreur lisible et internationalisé
 * @param {Error} error - L'erreur capturée (axios ou autre)
 * @param {Function} t - Fonction de traduction i18n
 * @returns {string} Message d'erreur traduit
 */
export const getErrorMessage = (error, t) => {
  // Cas 1: Erreur réseau/SSL (pas de réponse serveur)
  if (error.code && !error.response) {
    const key = ERROR_MAP[error.code] || 'errors.network';
    return t(key);
  }
  
  // Cas 2: Erreur HTTP avec réponse serveur
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data || {};
    
    // Priorité 0: Message du backend (pour restrictions, bans, etc.)
    // Si le backend envoie un message lisible, on l'utilise directement
    if (data.message && typeof data.message === 'string' && data.message.length > 0) {
      return data.message;
    }
    
    if (data.msg && typeof data.msg === 'string' && data.msg.length > 0) {
      return data.msg;
    }
    
    // Priorité 1: errorKey du backend (le plus spécifique)
    if (data.errorKey && ERROR_MAP[data.errorKey]) {
      return t(ERROR_MAP[data.errorKey]);
    }
    
    // Priorité 2: Code HTTP
    if (ERROR_MAP[status]) {
      return t(ERROR_MAP[status]);
    }
  }
  
  // Fallback: Message générique
  return t('errors.unknown');
};

/**
 * Helper pour les erreurs de validation frontend
 * @param {string} field - Nom du champ
 * @param {Function} t - Fonction de traduction
 * @returns {string} Message d'erreur
 */
export const getValidationError = (field, t) => {
  const key = `listing.errors.${field}Required`;
  return t(key);
};
